import ModalComponent from '../../common/ModalComponent/ModalComponent';
import EmojiCircle from '../../../assets/images/challenge-emoji-circle.svg';
import CloseIcon from '../../../assets/icons/challenge-modal-close.svg';
import styles from './AlreadyAppliedModal.module.css';

type AlreadyAppliedModalProps = {
  open: boolean;
  onClose: () => void;
};

export default function AlreadyAppliedModal({ open, onClose }: AlreadyAppliedModalProps) {
  return (
    <ModalComponent
      open={open}
      onClose={onClose}
      style={{ padding: 0 }}
      content={{
        borderRadius: '8px',
        boxShadow: '0 20px 24px -4px rgba(16, 24, 40, 0.08), 0 8px 8px -4px rgba(16, 24, 40, 0.03)',
      }}
      overlayProps={{ color: '#f2f2f2', opacity: 0.6, blur: 5 }}
    >
      <div className={styles.modal}>
        <button type="button" className={styles.closeButton} onClick={onClose} aria-label="Close">
          <img src={CloseIcon} alt="" width={24} height={24} />
        </button>
        <div className={styles.emojiCircle}>
          <img src={EmojiCircle} alt="" width={79} height={79} />
          <span className={styles.emoji}>🙌</span>
        </div>
        <div className={styles.textBlock}>
          <p className={styles.title}>You&apos;ve Already Applied</p>
          <p className={styles.description}>
            We&apos;ve already received your application. If there are any updates, we will reach out to you soon.
          </p>
        </div>
      </div>
    </ModalComponent>
  );
}
